import React, { Component } from 'react'
import { StaticBox, FlowTable } from 'components/basic'
import http from 'API/http'
import { default as moment } from 'moment-timezone'

class AccessOrderEvents extends Component {
  constructor (props) {
    super(props)
    this.state = {
      orderevents: [],
      loading: true
    }
  }
  componentDidMount () {
    this.getOrderEvents(this.props.id)
  }
  componentWillReceiveProps (props) {
    if (props.updated === this.props.updated) return false
    this.getOrderEvents(props.id)
  }
  async getOrderEvents (id) {
    this.setState({loading: true})
    var err, res
    [err, res] = await http.get('2.4/orderevents/', {
      'accessId': id
    })
    if (err) return this.setState({loading: false})
    this.setState({orderevents: res.data, loading: false})
  }

  render () {
    return (
      <StaticBox cols={12} icon='sliders' title='Order Events'>
        <FlowTable loading={this.state.loading} paginatable={5} data={this.state.orderevents.map(event => [
          event.order.operation,
          <span className={'label orders-label label-' + (event.order.state === 'DONE_FAILED' ? 'danger' : (event.order.state === 'IN_PROGRESS' ? 'warning' : 'success'))}><b>{event.order.state}</b></span>,
          event.order.service,
          event.order.message,
          moment(event.timestamp).utc().format('YYYY-MM-DD HH:mm:ss')
        ])}>
          <tr>
            <th className='buttons'>Operation</th>
            <th style={{'width': '120px'}}>State</th>
            <th>Service</th>
            <th>Message</th>
            <th>Time</th>
          </tr>
        </FlowTable>
      </StaticBox>
    )
  }
}
export default AccessOrderEvents



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/components/2.4/access/AccessOrderEvents.js